import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'starter-onboarding',
		path: '/p/:slug/starter-onboarding/:step',
		beforeServerRender: async (context) => {
			await petitionSlugCanonicalRedirect(context);
		},
		component: loadable(async () => import(/* webpackChunkName: "pages/starter_onboarding" */ './index'), {
			exportName: 'StarterOnboarding',
			fallback: Loading,
		}),
		frame: {
			footer: false,
			header: true,
		},
		restrictedAccess: {
			authOnly: true,
			role: canEditPetition('slug'),
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
		disableFullRerenderForParams: ['step'],
	},
];
